import Vue from 'vue'
import Constants from './constants'

export async function addHeaders(optionalHeaders) {
  let headers = Constants.HEADERS.DEFAULT.headers
  if (optionalHeaders) {
    headers = optionalHeaders
  }

  headers['Authorization'] = 'Bearer ' + await Vue.prototype.$auth.getTokenSilently()

  return headers
}
